import {EventFunc} from "types/types";
import * as React from "react";
import './BottomBackButton.pcss';

export const BottomBackButton = (props:{onClick:EventFunc, backLabel:string, style?:any, className?:string}) =>
  <div className={`bottom-back${props.className?' '+props.className:''}`} style={props.style}>
    <button onClick={props.onClick}>
      <span className="material-symbols-outlined" aria-hidden>arrow_back_ios</span>
      <span className={'lab'}>{props.backLabel}</span>
    </button>
  </div>
;
